import React, { useState } from "react";
import BankPdf from "../../pdf/BankCategory.pdf";
import OFIPdf from "../../pdf/OFICategory.pdf";
import MMOPdf from "../../pdf/MMOCategory.pdf";
import AggregatorPdf from "../../pdf/AggregatorCategory.pdf";
import BillerPdf from "../../pdf/BillersCategory.pdf";
import PSSPPdf from "../../pdf/PSSPCategory.pdf";
import Download from "../../assets/assets/download-pdf.svg";
import UserModal from "../../components/EmailModal/UserModal";
import { PropTypes } from "prop-types";

const Requirement = ({ categoryChoice }) => {
  const [state, setState] = useState({
    viewModal: false,
  });

  const openModal = () => {
    setState({
      ...state,
      viewModal: true,
    });
  };

  const closeModal = () => {
    setState({
      ...state,
      viewModal: false,
    });
  };

  return (
    <>
      <div className="download-btn">
        <button onClick={openModal}>
          <img src={Download} alt="download" /> &nbsp; &nbsp; View Requirement
        </button>

        <UserModal
          open={state.viewModal}
          close={closeModal}
          height={"739"}
          width={"1000"}
        >
          <div style={{ padding: "20px" }}>
            <span className="iframe-back2" onClick={() => closeModal()}>
              X
            </span>
            <embed
              src={
                (categoryChoice === 1 && BankPdf) ||
                (categoryChoice === 2 && OFIPdf) ||
                (categoryChoice === 3 && MMOPdf) ||
                (categoryChoice === 4 && PSSPPdf) ||
                (categoryChoice === 5 && BillerPdf) ||
                (categoryChoice === 6 && AggregatorPdf) ||
                 (categoryChoice === 7 && PSSPPdf)
              }
              type="application/pdf"
              width="100%"
              height="1000"
              title="Required Documents"
              name="Required Documents"
            ></embed>
          </div>
        </UserModal>
      </div>
    </>
  );
};

Requirement.propTypes = {
  categoryChoice: PropTypes.number
}

export default Requirement;
